import './scss/index.scss'
import {ToggleComponent} from './ToggleComponent'

const TogglePackage = {
    name: 'UIToggle',
    configure: function(config) {
        config.addComponent('UIToggle', ToggleComponent, false, 'toggle')
    }
}

export {TogglePackage}
